export const ID_ESTADO_PENDIENTE = 0
export const ID_ESTADO_ENVIADO = 1
export const ID_ESTADO_ENTREGADO = 2
export const ID_ESTADO_ENTREGA_OBSERVADA = 3
export const ID_ESTADO_MONTOS_OK = 4
export const ID_ESTADO_MONTOS_NO_OK = 5
export const ID_ESTADO_EN_ESPERA = 6
export const ID_ESTADO_PENDIENTE_PAGO = 7
export const ID_ESTADO_PEDIDO_CREADO = 8
export const ID_ESTADO_CANCELADO = 9
export const ID_ESTADO_DEVUELTO = 10
export const ID_ESTADO_NO_CONFIRMADO = 11
export const ID_INICIO_DE_CANCELACION = 13
export const ID_INICIO_DE_DEVOLUCION = 14
